module.exports = __webpack_public_path__ + "img/ExitusForce-C.0a0f9490.png";